import React from 'react';
import { FaUsers, FaInstagram, FaHandsHelping, FaVideo, FaUserFriends, FaMapMarkedAlt, FaNetworkWired } from 'react-icons/fa';
import { useLanguage } from '../../../contexts/LanguageContext';
import '../../styles/homeSectionB2.css';
import PersebaranForpasiImage from '../../../assets/persebaran-forpasi.png'

const HomeSectionB2 = () => {
  const { language } = useLanguage();

  const content = {
    id: {
      title: "FORPASI DALAM ANGKA",
      data: [
        { icon: <FaUsers />, value: '950+', label: 'Anggota Komunitas Digital (Whatsapp)' },
        { icon: <FaInstagram />, value: '606', label: 'Pengikut Instagram' },
        { icon: <FaHandsHelping />, value: '30.000+', label: 'Engagement Media Sosial' },
        { icon: <FaVideo />, value: '23', label: 'Rekaman Webinar & Kegiatan' },
        { icon: <FaUserFriends />, value: '50+', label: 'Relawan Terlibat' },
        { icon: <FaMapMarkedAlt />, value: '20', label: 'Area Cakupan Koordinator Wilayah' },
        { icon: <FaNetworkWired />, value: '20+', label: 'Jaringan Lembaga Kolaborator' },
      ]
    },
    en: {
      title: "FORPASI IN NUMBERS",
      data: [
        { icon: <FaUsers />, value: '950+', label: 'Digital Community Members (Whatsapp)' },
        { icon: <FaInstagram />, value: '606', label: 'Instagram Followers' },
        { icon: <FaHandsHelping />, value: '30,000+', label: 'Social Media Engagement' },
        { icon: <FaVideo />, value: '23', label: 'Webinar & Event Recordings' },
        { icon: <FaUserFriends />, value: '50+', label: 'Volunteers Involved' },
        { icon: <FaMapMarkedAlt />, value: '20', label: 'Regional Coordinator Areas' },
        { icon: <FaNetworkWired />, value: '20+', label: 'Collaborating Institutions Network' },
      ]
    }
  };

  const currentContent = content[language] || content.id;

  const topCards = currentContent.data.slice(0, 4);
  const bottomCards = currentContent.data.slice(4, 7);

  return (
    <section className="home-sectionB2">
      <h2>{currentContent.title}</h2>
      
      <div className="impact-grid-container">
        {/* Baris Atas: 4 Card */}
        <div className="impact-row">
          {topCards.map((item, idx) => (
            <div className="impact-card" key={`top-${idx}`}>
              <div className="impact-icon">{item.icon}</div>
              <h3>{item.value}</h3>
              <p>{item.label}</p>
            </div>
          ))}
        </div>

        {/* Baris Bawah: 3 Card */}
        <div className="impact-row">
          {bottomCards.map((item, idx) => (
            <div className="impact-card" key={`bottom-${idx}`}>
              <div className="impact-icon">{item.icon}</div>
              <h3>{item.value}</h3>
              <p>{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="impact-image-section">
        <div className="impact-image-box">
          <img src={PersebaranForpasiImage} alt="FORPASI Impact" />
        </div>
      </div>
    </section>
  );
};

export default HomeSectionB2;
